function exportarCurriculoPdf($scope, $filter) {
	
	var logoUrl = HOME_URL+'assets/img/marca.png';
    
    imageToDataURL(logoUrl, function(dataUrl) {
    	_savePdf($scope, $filter, dataUrl);
    });
	
}

function _savePdf($scope, $filter, imageBase64) {
    function getDescriptionBoolean(value) {
        return value == "true" ? "Sim" : "Não";
    }

    var curriculum = $scope.curriculum;
    var experiences = $scope.experiences || [];
    
    var doc = new jsPDF();
    
    doc.addImage(imageBase64, 'PNG', 20, 10, 30, 23);

    doc.setFontSize(18);
    doc.text(90, 20, "Currículo");

    // DADOS PESSOIAS
    doc.setFontSize(16);
    doc.text(20, 45, 'Dados Pessoais');

    doc.setFontSize(11);
    doc.text(20, 55, 'Nome: ' + curriculum.name);
    doc.text(120, 55, 'E-mail: ' + curriculum.email);

    doc.text(20, 63, 'CPF: ' + curriculum.cpf);
    doc.text(120, 63, 'Data de nascimento: ' + $filter('date')(curriculum.dateBirth, "dd/MM/yyyy"));

    doc.text(20, 71, 'Estado civil: ' + curriculum.civilStatus);
    doc.text(120, 71, 'Gênero: ' + curriculum.gender);

    doc.text(20, 79, 'Telefone fixo: ' + curriculum.homePhone);
    doc.text(120, 79, 'Telefone celular: ' + curriculum.cellPhone);

    // ENDERECO
    doc.setFontSize(16);
    doc.text(20, 100, 'Endereço');

    doc.setFontSize(11);
    doc.text(20, 115, 'CEP: ' + curriculum.address.zipCode);
    doc.text(80, 115, 'Número: ' + curriculum.address.number);
    doc.text(140, 115, 'Bairro: ' + curriculum.address.neighborhood);

    doc.text(20, 123, 'Estado: ' + curriculum.address.city.state.name);
    doc.text(80, 123, 'Cidade: ' + curriculum.address.city.name);
    doc.text(140, 123, 'Complemento: ' + curriculum.address.complement);

    // INFORMACOES
    doc.setFontSize(16);
    doc.text(20, 144, 'Informações');

    doc.setFontSize(11);
    doc.text(20, 159, 'Área de interesse: ' + curriculum.areasInterest);
    doc.text(120, 159, 'Disponibilidade: ' + curriculum.availability);

    doc.text(20, 165, '-------------------------------------------------------------------------------------------------------------------------------------');

    doc.text(20, 175, 'Este cadastro será para seu primeiro emprego:');
    doc.text(20, 182, getDescriptionBoolean(curriculum.isFirstJob));

    doc.text(20, 195, 'Viagens:');
    doc.text(20, 202, getDescriptionBoolean(curriculum.isAvailableTrip));

    doc.text(20, 215, 'Disponibilidade para Mudança de Cidade:');
    doc.text(20, 222, getDescriptionBoolean(curriculum.isAvailableCityChange));

    doc.text(20, 235, 'Possui condução própria:');
    doc.text(20, 242, getDescriptionBoolean(curriculum.isDriving));

    doc.text(20, 255, 'Portador de necessidades especiais:');
    doc.text(20, 262, getDescriptionBoolean(curriculum.isWithSpecialNeed));

    doc.text(20, 275, 'Tem filhos:');
    doc.text(20, 282, getDescriptionBoolean(curriculum.hasSon));

    // NOVA PAGINA
    doc.addPage()

    doc.text(20, 20, 'Pretensão salarial:');
    doc.text(20, 27, curriculum.wageClaim);

    // FORMAÇÃO
    doc.setFontSize(16);
    doc.text(20, 50, 'Formação');

    doc.setFontSize(11);
    doc.text(20, 63, 'Nível:');
    doc.text(20, 70, curriculum.schooling.literacy);

//    doc.text(120, 63, 'Formação técnica:');
//    doc.text(120, 70, curriculum.schooling.technicalGraduation);

    doc.text(20, 83, 'Instituição:');
    doc.text(20, 90, curriculum.schooling.institution);

    doc.text(120, 83, 'idiomas:');
    doc.text(120, 90, curriculum.schooling.language);

    doc.text(20, 103, 'Curso:');
    doc.text(20, 110, curriculum.schooling.course);

    doc.text(120, 103, 'Cursos Extracurriculares:');
    doc.text(120, 110, curriculum.schooling.specialization);

    if (experiences) {
        // ULTIMOS EMPREGOS
        doc.setFontSize(16);
        doc.text(20, 130, 'Últimos empregos');

        doc.setFontSize(11);

        var dimensionJob = {
            lineFirst: 20, 
            lineSecond: 80, 
            lineThree: 140,
            columnTitleFirst: 143, 
            columnValueFirst: 150, 
            columnTitleSecond: 163,
            columnValueSecond: 170,
            columnTitleThird: 183,
            columnValueThird: 190,
            separator: 180,
            up: 50
        }

        for (var i = 0; i < experiences.length; i++) {
            var experience = experiences[i];

            if (i == 3) {
                doc.addPage();
                dimensionJob.up = -220;
            } else if (i > 3) {
                dimensionJob.up = 50;
            }

            if (i > 0) {
                dimensionJob.columnTitleFirst += dimensionJob.up;
                dimensionJob.columnValueFirst += dimensionJob.up;
                dimensionJob.columnTitleSecond += dimensionJob.up;
                dimensionJob.columnValueSecond += dimensionJob.up;
                dimensionJob.columnTitleThird += dimensionJob.up;
                dimensionJob.columnValueThird += dimensionJob.up;
                dimensionJob.separator += dimensionJob.up
            }

            doc.text(dimensionJob.lineFirst, dimensionJob.columnTitleFirst, 'Empresa:');
            doc.text(dimensionJob.lineFirst, dimensionJob.columnValueFirst, experience.company);

            doc.text(dimensionJob.lineSecond, dimensionJob.columnTitleFirst, 'Início:');
            doc.text(dimensionJob.lineSecond, dimensionJob.columnValueFirst, $filter('date')(experience.admissionDate, "dd/MM/yyyy"));

            doc.text(dimensionJob.lineThree, dimensionJob.columnTitleFirst, 'Fim:');
            if (experience.isActual) {
                doc.text(dimensionJob.lineThree, dimensionJob.columnValueFirst, "Emprego atual");
            } else {
                doc.text(dimensionJob.lineThree, dimensionJob.columnValueFirst, $filter('date')(experience.dateOut, "dd/MM/yyyy"));
            }

            doc.text(dimensionJob.lineFirst, dimensionJob.columnTitleSecond, 'Função:');
            doc.text(dimensionJob.lineFirst, dimensionJob.columnValueSecond, experience.positionHeld);

            doc.text(dimensionJob.lineSecond, dimensionJob.columnTitleSecond, 'Remuneração:');
            doc.text(dimensionJob.lineSecond, dimensionJob.columnValueSecond, experience.lastSalary);

            var activities_to_print = doc.splitTextToSize(experience.activities, 180);
            
            doc.text(dimensionJob.lineFirst, dimensionJob.columnTitleThird, 'Principais atividades executadas:');
            doc.text(dimensionJob.lineFirst, dimensionJob.columnValueThird, activities_to_print);

            if (experiences[i + 1]) {
                doc.text(20, dimensionJob.separator, '-----------------------------------------------------------------------------------------------------------------------------------------');
            }
        }
    }

    // SAVE
    doc.save('curriculo.pdf');
}

function imageToDataURL(url, callback) {
	  var xhr = new XMLHttpRequest();
	  xhr.onload = function() {
	    var reader = new FileReader();
	    reader.onloadend = function() {
	      callback(reader.result);
	    }
	    reader.readAsDataURL(xhr.response);
	  };
	  xhr.open('GET', url);
	  xhr.responseType = 'blob';
	  xhr.send();
}